<i18n>
{
  "de": {
    "offerNoAccess": "bietet aktuell keinen Zugriff auf diesen Beitrag.",
    "postWithoutActivePurchasable": "Dieser Beitrag ist momentan keinem aktiven Angebot zugeordnet."
  },
  "en": {
    "offerNoAccess": "currently does not offer access to this item.",
    "postWithoutActivePurchasable": "This post is not linked to an active offer."
  }
}
</i18n>

<template>
  <div class="post-locked">
    <div
      class="is-flex"
      :class="{ 'mt-10': hasOffers || post.limitToFollowers }"
    >
      <div
        v-if="hasOffers"
        class="mr-10"
      >
        <postPurchaseButton
          v-if="user.artist"
          :post="post"
        />
      </div>
      <div v-if="post.limitToFollowers">
        <postFollowButton v-if="user.artist" />
      </div>
    </div>
    <article
      v-if="!hasOffers && !post.limitToFollowers"
      class="placeholder"
    >
      <div class="placeholder-content-wrapper">
        <div class="placeholder-text">
          <p class="placeholder-heading">
            {{ artist.nickname }} {{ $t('offerNoAccess') }}
          </p>
          <div class="mt-10">
            {{ $t('postWithoutActivePurchasable') }}
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import postFollowButton from '~/components/post-follow-button'
import postPurchaseButton from '~/components/post-purchase-button'

export default {
  name: 'post-locked',
  props: ['user', 'post'],

  components: {
    postFollowButton,
    postPurchaseButton
  },

  computed: {
    postRewards() {
      return this.artist.rewards
        .filter(r => this.post.limitToReward.includes(r._id.toString()))
    },
    availableProducts() {
      return this.artist.products.filter(p => {
        return p.stockRemaining === null || p.stockRemaining > 0
      })
    },
    postProducts() {
      return this.availableProducts
        .filter(p => this.post.limitToProduct.includes(p._id.toString()))
    },

    hasOffers() {
      return this.postRewards.length || this.postProducts.length
    },

    ...mapState(['artist'])
  },

  methods: {}
}
</script>

<style lang="scss">
@import 'assets/sass/_variables';
@import 'assets/sass/icons';

.placeholder {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-around;

  .same-min-width {
    min-width: 100px;

    button {
      min-width: 100px;
    }
  }

  .placeholder-content-wrapper {
    .placeholder-text {
      text-align: center;

      padding: 30px;
      box-shadow: 0px 0px 12px 0px #cfcfcf;

      font-size: 0.9rem;
      color: #1e1c25;

      .placeholder-heading {
        font-size: 1.4rem;
        line-height: 1.6rem;
      }

      .purchasable-list {
        padding: 0px;
        margin-left: 0px;
        display: block;
        list-style: none;
        order: 0;

        li {
          display: block;
        }
      }

      .link-dark-bg {
        &:hover {
          color: $light;
        }
      }
    }
  }
}

@media screen and (max-width: $mobile) {
  .placeholder-text {
    margin: 1rem !important;
    padding: 1rem !important;
    font-size: 0.8rem !important;
    line-height: 1rem !important;
  }
}

@media screen and (min-width: $desktop) {
  .placeholder {
    width: 100%;
    overflow: hidden;
    overflow: visible;
  }
}
</style>
